import { Box } from "@mui/material";
import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import TransactionMenu from "./TransactionMenu";
import Ordermappingmodule from "../ordermanagement/ordermapping";
 
// import TransactionMenu from "./Transaction-menu";
// import Ordermappingmodule from "../salesorder/ordermappingmodule";
// import OrderSelection from "../decklematching/deckleOrderSelection";
// import OptrimDeckleMatching from ".";
// import ShortCloseOrders from "./Short-close-orders";
 
 
const TransactionIndex = () => {
    const [activePage, setActivePage] = useState('ViewMainPage');
 
    const SetActive = (page) => {
        setActivePage(page);
    }
 
    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }
    return (
        <Box position="relative">
            {activePage === "ViewMainPage" && (<TransactionMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}
            {/* 1.Paper  Machine Production Entry */}
            {activePage === "Order Mapping" && (
                <Ordermappingmodule handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {/* {activePage === "Order selection" && (
                <OrderSelection handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
 
            {activePage === "Deckle Matching" && (
                <OptrimDeckleMatching handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
 
            {activePage === "Short Close" && (
                <ShortCloseOrders handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}
 
            {/* ShortCloseOrders */}
        </Box>
 
    );
 
};
export default TransactionIndex;